module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/ava-franks-4b1d645eed2e4ebd6f94cd4009754e88.jpg";